import axios from "axios";
import { baseUrl, apiToken } from "../utils/base_url";

export const fetchPageData = async (
  endpoint,
  setter,
  setLoader = () => {},
  allData,
  allCats = false,
  setPagingation,
  news
) => {
  setLoader(true);
  try {
    const res = await axios.get(`${baseUrl}/api/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${apiToken}`,
      },
    });
    // console.log("API Response", res);
    if (allCats) {
      setter(res?.data?.data);

      {
        setPagingation && setPagingation(res?.data?.meta?.pagination);
      }
    } else {
      setter(
        allData
          ? news
            ? { allData, newsCard: res?.data?.data }
            : { allData, blogs: res?.data?.data }
          : res?.data?.data[0]
      );
    }
    setLoader(false);
    return res?.data;
  } catch (error) {
    console.log(error);
    return;
  }
};
